// extracted by mini-css-extract-plugin
export default {"region-box":"agendaConfig_region-box__z0Wfn","region-box-chart":"agendaConfig_region-box-chart__tVqHE","region-box-header":"agendaConfig_region-box-header__vdsMv"};